import React from 'react';

// Components
import { Button } from '../../../../components/buttons';

// Utils
import { BMOi18n } from '@/utils/bmo-gif/constants';

type LegacyBMOGIFEmptyStateProps = {
  locale: string;
  openEditBMOContactModal: () => void;
  showSelectContactModal: () => void;
};

const LegacyBMOGIFEmptyState: React.FC<LegacyBMOGIFEmptyStateProps> = ({ locale, openEditBMOContactModal, showSelectContactModal }) => (
  <>
    <Button className="contact-action-btn create-contact" onClick={openEditBMOContactModal}>
      <i className="icon-plus-thin" />
      {BMOi18n[locale].CREATE_CLIENT}
    </Button>

    <Button className="contact-action-btn select-contact" onClick={showSelectContactModal}>
      <i className="icon-user" />
      {BMOi18n[locale].SELECT_CLIENT}
    </Button>
  </>
);

export default LegacyBMOGIFEmptyState;
